import Phaser from 'phaser';

export default class TimerDisplay extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene
   */
  constructor(scene) {
    super(scene);

    this.borderWidth = 2;
    this.barWidth = 260;
    this.barHeight = 10;

    this.border = this.scene.add.rectangle(0,0,this.barWidth + this.borderWidth, this.barHeight + this.borderWidth, 0xffffff, 0).setOrigin(0)
      .setStrokeStyle(this.borderWidth, 0xffffff, 1);

    this.progressBarDisplay = this.scene.add.rectangle(this.borderWidth / 2,this.borderWidth / 2,this.barWidth,this.barHeight,0xffffff, 1).setOrigin(0);
    this.add([this.progressBarDisplay, this.border]);
    this.drawProgress();
  }

  drawProgress () {
    this.progressBarDisplay.setDisplaySize(this.barWidth * this.progress, this.barHeight);
  }

  setProgress (value) {
    this.progress = value;
    this.drawProgress();
  }
}